module.exports = __webpack_public_path__ + "static_cfjt/img/logo.d21bed92.jpg";